import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export type GetJiraIssuesRequest = {
	maxIssues?: number;
	searchText: string;
};

export type GetJiraIssuesResponse = {
	projectKey: string;
	issueKey: string;
	issueName: string;
	statusId: string;
};

export const getJiraIssues = createGetEndpoint<GetJiraIssuesRequest, Array<GetJiraIssuesResponse>>(
	(request) => `/api/v3/jira/issues?${getQueryString(request)}`
);
